import { IconPropsType } from '..';

export const ProcessingIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.21513 13.5556H3.77068V18M11.7707 6.44444H16.2151V2M3.40002 7.33636C3.89841 6.10281 4.73285 5.03381 5.80851 4.25087C6.88416 3.46792 8.159 3.00224 9.48602 2.90712C10.813 2.812 12.1393 3.09102 13.3157 3.71254C14.492 4.33406 15.4696 5.27337 16.1388 6.42322M16.5863 12.6641C16.0879 13.8976 15.2535 14.9666 14.1778 15.7496C13.1021 16.5325 11.8286 16.9976 10.5016 17.0927C9.17457 17.1878 7.84719 16.9088 6.67086 16.2873C5.49453 15.6658 4.5163 14.7267 3.84707 13.5768"
      stroke="#8388A3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
